import { FormFieldPresets } from '@domain/form-field-presets';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

const getFormFieldsPresets = async () => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/form-field-presets`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetFormFieldsPresets = () => {
  return useGenericQuery<FormFieldPresets, RequestError>([QUERY_KEYS.getFormFields], () => getFormFieldsPresets(), {
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
